export interface ExcavationSite {
  id: string;
  name: string;
  location: string; // City or Region
  period: string; // e.g., Neolithic, Roman
  description?: string;
  lat: number;
  lng: number;
  startYear?: number;
  endYear?: number;
  status?: 'active' | 'completed' | 'planned';
  unescoStatus?: 'world_heritage' | 'tentative' | null;
}

export interface PredictedSite {
  name: string;
  lat: number;
  lng: number;
  reason: string;
  period: string;
}

export interface PredictionResult {
  analysis: string;
  suggestedLocations: GroundingChunk[];
  predictedSites: PredictedSite[];
  model?: string;
  usage?: {
    prompt_tokens: number;
    completion_tokens: number;
    total_tokens: number;
  };
}

export interface GroundingChunk {
  maps?: {
    uri: string;
    title: string;
    placeAnswerSources?: {
      reviewSnippets?: {
        text: string;
      }[];
    };
  };
  web?: {
    uri: string;
    title: string;
  };
}

export interface PeriodInfo {
  name: string;
  count: number;
  info?: {
    timeRange: string;
    description: string;
    characteristics: string[];
  };
}

export interface LocationInfo {
  name: string;
  count: number;
}

export interface Stats {
  totalSites: number;
  periodDistribution: { name: string; count: number }[];
  locationDistribution: { name: string; count: number }[];
  unescoWorldHeritageSites: number;
  unescoSitesList: string[];
}

export enum AppState {
  IDLE,
  LOADING,
  ANALYZING,
  SUCCESS,
  ERROR
}

export interface ApiError {
  message: string;
  code?: string;
}
